import React, { useState } from 'react';
import { TextbausteineModal } from '../components/TextbausteineModal/TextbausteineModal';

export const useModals = () => {
  const [modals, setModals] = useState([]);
  const [selectedTextBausteine, setSelectedTextBausteine] = useState(null);

  const handleOpenTextbausteine = (field, label, category) => {
    setModals((prev) => [...prev, { field, label, category, open: true }]);
  };

  const handleCloseTextbausteine = (index, newTextBaustein) => {
    setModals((prev) => {
      const updated = [...prev];
      updated[index].open = false;
      return updated;
    });
    if (newTextBaustein && typeof newTextBaustein === 'string') {
      setSelectedTextBausteine(newTextBaustein);
    }
  };

  const renderModals = () =>
    modals.map((modal, index) => (
      <TextbausteineModal
        key={index}
        field={modal.field}
        label={modal.label}
        category={modal.category}
        open={modal.open}
        onClose={(val) => handleCloseTextbausteine(index, val)}
      />
    ));

  return {
    modals,
    handleOpenTextbausteine,
    handleCloseTextbausteine,
    renderModals,
    selectedTextBausteine,
  };
};
